<app-waves-background />

<app-dashboard-layout [routerPath]="(routerPath$ | async) ?? ''" >
  <div class="px-6 pt-4">
    <zaeper-mfa-reminder-banner
      [mfaEnabled]="mfaEnabled()"
      (actionClicked)="goToMfaSettings()"
    ></zaeper-mfa-reminder-banner>
  </div>
  <router-outlet></router-outlet>
</app-dashboard-layout>

<zaeper-toast />
<p-confirm-dialog />
<app-blocking-loading-indicator />
<zaeper-blocking-loader />
